import { Component } from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {Storage} from '@ionic/storage';
import 'leaflet';
declare const L: any;
import 'leaflet.markercluster';
import * as moment from 'moment';
import {SensorUtilService} from "../../services/sensors.service";
import {SocketService} from "../../services/socket.service";
import {AssetsService} from "../../services/assets.service";
import {UtilsService} from "../../services/utils.service";
import {AuthService} from "../../services/auth.service";
import {LoginPage} from "../login/login";
import {GlobalVariable} from "../../services/global.vars";


@Component({
  selector: 'page-realtime-multi',
  templateUrl: 'realtime.multi.html'
})
export class RealtimeMultiPage{

  private assets: any = [];
  private map : any;
  private cluster : any;
  private markersList: any = [];
  private baseLayers: any;
  private baseLayersKeys:any = [];


  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public socketService: SocketService,
              public storage: Storage,
              public authService: AuthService,
              public utilsService: UtilsService,
              public assetsService: AssetsService,
              private sensorUtilService: SensorUtilService) {

    this.assets = navParams.get('assets');
  }

  private selectedBaseLayerKey: string;
  private HIDE_DISPUTED_BOUNDARIES=GlobalVariable.HIDE_DISPUTEDBOUNDARIES?"&apistyle=s.t:17|s.e:all|p.v:off":"";

  public baseLayer : any = {
    NGI: L.tileLayer.wms(GlobalVariable.TILE_URL, {
      maxZoom: 19,
      name: "NGI",
      attribution: 'Powered iaxeed',
      icon: 'ngiMap.png'
    }),
    googleRoadmap: L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}'+this.HIDE_DISPUTED_BOUNDARIES, {
      maxZoom: 19,
      name: "Google Map",
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      icon: 'gNorm.png'

    }),

    googleTerrain: L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}'+this.HIDE_DISPUTED_BOUNDARIES, {
      maxZoom: 19,
      name: "Google Satellite",
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      icon: 'gSat.png'

    }),
    googleHybrid: L.tileLayer('http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}'+this.HIDE_DISPUTED_BOUNDARIES, {
      maxZoom: 19,
      name: "Google Hybride",
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      icon: 'gHybr.png'

    }),
    osm: L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      name: "Open Street",
      icon: 'osmMap.png'

    })
  };
  initMap(){
    this.map.options.attributionControl = true;
    this.map.attributionControl.setPrefix('');
    this.map.whenReady(()=>{
      this.storage.ready().then(()=>{
        this.storage.get('baselayer').then((baselayer)=>{
          this.changeBaseLayer(baselayer);
        })
      })
    })
 
  }

  changeBaseLayer(key) {
    for (let k in this.baseLayer) {
      if (this.map.hasLayer(this.baseLayer[k])){
        this.map.removeLayer(this.baseLayer[k]);
      }
    }

    this.storage.ready().then(()=>{
      this.storage.set('baselayer', key).then(()=>{
        this.storage.get('baselayer').then((bLayer)=>{
          this.selectedBaseLayerKey = bLayer;
          this.map.addLayer(this.baseLayer[bLayer]);
        })
      });
    });

  };

  ngOnInit() {
    this.baseLayers = this.baseLayer;
    this.baseLayersKeys = Object.keys(this.baseLayers);
    this.map = new L.Map('mapRTMulti', {
      maxZoom: 19
    });
    this.initMap();

    this.loadMarkerCluster(true);

    this.socketService.on('newMsg').subscribe((data :any)=>{
      for(let asset of this.assets){
        if(data._id === asset._id){
          // console.log('ddddddddddddddd',data)
          this.markersList = [];
          this.assets[this.assets.indexOf(asset)] = data;
          this.assets = this.assetsService.getAssetsIcons(this.assets);
          this.loadAddress();

          this.cluster.clearLayers();
          this.loadMarkerCluster(false);
        }
      }




    })

  }


  loadAddress(){
    let coordinates = [];
    let result = [];
    for(let asset of this.assets) {
      if (asset.rt && asset.rt.loc && asset.rt.loc.coordinates && asset.rt.loc.coordinates[1] && asset.rt.loc.coordinates[0]) {
        coordinates.push([asset.rt.loc.coordinates[0], asset.rt.loc.coordinates[1]])
      } else {
        coordinates.push([0, 0])

      }
    }

    if (coordinates.length > 0){
      this.utilsService.getAddress(coordinates).subscribe(data => {
        let res = data.BND.BatchResults;

        if (res.length > 0) {
          for(let value of res){
            if (value.Elements.count > 0) {
              let element = value.Elements.Element[0];
              let address = this.utilsService.format(element);
              result.push(address);
            }
            else
              result.push("NOT_AVAILABLE")
          }
        }


        let i = 0;
        for(let asset of this.assets) {
          if (asset.rt && asset.rt.loc && asset.rt.loc.coordinates && asset.rt.loc.coordinates[1] && asset.rt.loc.coordinates[1] !== 0 && asset.rt.loc.coordinates[0] && asset.rt.loc.coordinates[0] !== 0)
            asset.address = result[i];
          i++;
          this.getAssetSensors(asset);
        }
      });
    }
  }

  getAssetSensors(asset){
    let sensors = asset.sensors;
    asset.sensorData = [];
    if(sensors.length > 0){
      for(let sensor of sensors){
        let sensorName = sensor.name;
        let src = sensor.src.slice(sensor.src.lastIndexOf('.') + 1);
        if (sensor.type && sensor.src && Number.isFinite(asset.rt.io[src])) {
          let realVal = asset.rt.io[src];
          if (this.sensorUtilService.getSensorFamily(sensor.type) === "ANALOGIC") {
            if (Number.isFinite(sensor.minSrc) && Number.isFinite(sensor.maxSrc) && Number.isFinite(sensor.min) && Number.isFinite(sensor.max)) {
              realVal = this.sensorUtilService.getRealSensorValue(asset.rt.io[src], sensor.minSrc, sensor.maxSrc, sensor.min, sensor.max, sensor.gaps, sensor);
            }
            if(sensor.type == "FUEL_LEVEL")
            sensor.value_pourcent =
                        (realVal / sensor.max) * 100;
                      
                        if (Number.isFinite(realVal))
                          asset.sensorData.push({
                            name: sensorName,
                            type: sensor.type,
                            family: sensor.family,
                            unit: sensor.unit,
                            value: parseFloat(realVal.toFixed(2)),
                            value_pourcent:sensor.value_pourcent ? parseFloat(sensor.value_pourcent.toFixed(2)) :null
                          });
          }
          if (this.sensorUtilService.getSensorFamily(sensor.type) === "BINARY") {
            asset.sensorData.push({
              name: sensorName,
              type: sensor.type,
              family: sensor.family,
              ON: sensor.ON,
              OFF: sensor.OFF,
              value:realVal,
              status: realVal === sensor.ON ? this.sensorUtilService.getSensorsTypes().STATUS[sensor.type].enabled
              :  this.sensorUtilService.getSensorsTypes().STATUS[sensor.type].disabled,
              class: realVal === sensor.ON ? "is-on" : "is-off"
            });
          }
        }
      }
    }
  }

  loadMarkerCluster(isInit) {
    if(this.assets) {

      this.cluster = L.markerClusterGroup();
    this.markersList = [];
  for (let asset of this.assets) {
    let odometer: number = 0;

    if (asset.rt) {
      let data = {
        name: "",
        family: "",
        date: "",
        spd: "",
        ang: 0,
        odo: "",
        lng: 0,
        lat: 0,
        con: 0,
        gps_dt: null,
        address: ""
      };

      data.name = asset.name;

      if (asset.family) {
        data.family = asset.family;
      }
      if (asset.sensors.length > 0) {

        let sensors = asset.sensors;
        if (sensors.length > 0) {
          for (let sensor of sensors) {
            let src = sensor.src.slice(sensor.src.lastIndexOf('.') + 1);
            if (sensor.type && sensor.type === "ODOMETER" && sensor.src && Number.isFinite(asset.rt.io[src])) {
              let realVal = asset.rt.io[src];
              if (Number.isFinite(sensor.minSrc) && Number.isFinite(sensor.maxSrc) && Number.isFinite(sensor.min) && Number.isFinite(sensor.max)) {
                realVal = this.sensorUtilService.getRealSensorValue(asset.rt.io[src], sensor.minSrc, sensor.maxSrc, sensor.min, sensor.max, sensor.gaps, sensor);
              }
              if (Number.isFinite(realVal)) {
                odometer = parseFloat(realVal.toFixed(2));
              }
            }
          }
        }
      }

      if (asset.rt.gps_dt) {
        data.gps_dt = moment(asset.rt.gps_dt);
      }
      if (odometer)
        data.odo = odometer.toString();
      else if (asset.rt.odo) {
        data.odo = Math.round(asset.rt.odo).toFixed(1);
      }

      if (asset.rt.io) {
        if (asset.rt.io.spd) {
          data.spd = asset.rt.io.spd;
        }
        if (asset.rt.io.ang) {
          data.ang = asset.rt.io.ang;
        }
        if (asset.rt.io.con) {
          data.con = asset.rt.io.con;
        }
      }

      if (asset.rt.loc) {
        if (asset.rt.loc.coordinates && asset.rt.loc.coordinates[1] && asset.rt.loc.coordinates[1] !== 0 && asset.rt.loc.coordinates[0] && asset.rt.loc.coordinates[0] !== 0) {
          data.lng = asset.rt.loc.coordinates[0];
          data.lat = asset.rt.loc.coordinates[1];
        }
      }

      if (asset.address) {
        data.address = asset.address;
      }

      if (data.lng !== 0 && data.lat !== 0) {
        let content = '<div class="map-popup"><div class="popup-heading fa fa-car"> ' + data.name + '</div><div class="popup-details">';
        if (data.gps_dt != null) {
          content += '<div  class="fa fa-clock-o"><b> Date</b></div> ' + moment(data.gps_dt).format('DD/MM/YYYY HH:mm:ss') + '<br/>';
        }
        if (data.spd !== "") {
          content += '<div  class="fa fa-tachometer"><b> Vitesse</b></div> ' + data.spd + ' km/h<br/>';
        }
        if (data.odo !== "") {
          content += '<div  class="fa fa-calculator"><b>Kilomètrage</b></div> ' + parseFloat(parseFloat(data.odo).toFixed(2).toString()) + ' km<br/>';
        }
        if (data.address !== "") {
          content += '<div  class="fa fa-map-marker"><b>Adresse</b></div> ' + data.address;
        }
        content += '</div>';

        let assetIcon = L.divIcon({
          html: '<img src="' + asset.icons.up + '" style="width: 30px; height: 62px;transform: rotate(' + data.ang + 'deg);  -webkit-transform: rotate(' + data.ang + 'deg); -moz-transform:rotate(' + data.ang + 'deg);" />',
          iconSize: [30, 62],
          iconAnchor: [6, 15]
        });

        let marker = new L.Marker(new L.LatLng(data.lat, data.lng),
          {
            icon: assetIcon
          }).bindPopup(content);

        let label = "<span class='tooltip-name'>" + data.name + "</span>";
        if (data.spd != "") {
          label += "<br><span class='tooltip-speed'>" + data.spd + " Km/h</span>";
        }

        marker.bindTooltip(label, {
          direction: 'right',
          permanent: true,
          offset: [15, 0],
          className: 'tooltip-marker'
        });
        this.cluster.addLayer(marker);
        this.markersList.push(marker)

      }
    }
  }

  this.map.addLayer(this.cluster);
  // console.log('xxxxxxxxxxxxxxZZZZ',this.map.getZoom())
if(isInit) this.map.fitBounds(this.cluster.getBounds());
//  this.map.setView([35.63475,9.8203957], 8);
}
  }

  goBack(){
    this.navCtrl.pop();
  }


  logout(){
    this.authService.disconnect().then(()=>{
      this.navCtrl.setRoot(LoginPage);
    })
  }
}


// WEBPACK FOOTER //
// ./src/pages/realtime/realtime.multi.ts